const STATUS = Object.freeze({
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
});

export const API = Object.freeze({
  TODOS: 'todos',
});

export default STATUS;
